<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="documents"
        :footer-props="{ 'items-per-page-options': [20, 30, 40, -1] }"
        item-key="id"
        group-by="title"
      >
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.actions="{ item }">
          <v-icon
            v-if="item.status === 'completed'"
            @click="downloadDocument(item)"
          >
            mdi-download
          </v-icon>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:group.header="{ group, headers, toggle, isOpen }">
          <td :colspan="headers.length">
            <v-btn @click="toggle" x-small icon :ref="group">
                <v-icon v-if="isOpen">mdi-minus</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
            <span class="mx-5 font-weight-medium">{{ group }}</span>
          </td>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'UserSignatures',
  data: () => ({
    headers: [
      {
        text: 'Id',
        align: 'start',
        value: 'id',
        sortable: false,
      },
      { text: 'Created', value: 'createdDate' },
      { text: 'Closed', value: 'closedDate' },
      { text: 'Title', value: 'title' },
      { text: 'Status', value: 'status' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  computed: {
    documents() {
      return this.$store.state.signedDocuments;
    },
  },
  methods: {
    downloadDocument(value) {
      this.$store.dispatch('downloadSignedDocument', value);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
